import * as L from 'leaflet';
import { Marker } from 'react-leaflet';
import 'leaflet-rotatedmarker';
import { PropsWithChildren, RefObject, useEffect, useRef } from 'react';
import { useSelectedMarkerPopupReady } from './useSelectedMarkerPopupReady';
import { RotatableMarkerProps } from '../rotatable-marker/RotatableMarker';

export interface RotatableClusterMarkerProps extends RotatableMarkerProps {
  isSelected?: boolean; // when true, ensure popup is opened
  clusterGroupRef?: RefObject<L.MarkerClusterGroup>;
}

export function RotatableClusterMarker({
  icon,
  position,
  heading,
  eventHandlers,
  children,
  isSelected,
  clusterGroupRef,
}: PropsWithChildren<RotatableClusterMarkerProps>) {
  const ref = useRef<L.Marker>(null);
  const openPopupReady = useSelectedMarkerPopupReady(ref, isSelected || false);

  const safeHeading = heading ?? 0;

  useEffect(() => {
    ref.current?.setRotationAngle(safeHeading);
  }, [safeHeading]);

  useEffect(() => {
    const marker = ref.current;
    const clusterGroup = clusterGroupRef?.current;

    if (isSelected && marker && clusterGroup && openPopupReady) {
      clusterGroup.zoomToShowLayer(marker, () => {
        marker.openPopup();
      });
    }
  }, [clusterGroupRef, isSelected, openPopupReady]);

  return (
    <Marker
      ref={ref}
      icon={icon}
      position={position}
      rotationAngle={safeHeading}
      eventHandlers={eventHandlers}
    >
      {children}
    </Marker>
  );
}

export default RotatableClusterMarker;
